import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function TravellerLoyalty() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Loyalty</Heading>
      <Accordion size="large" heading="Can I add my frequent flyer programs to my account?">
        <BodyText variant="large">
          Yes, you can add your frequent flyer programs to your account by accessing your account details. Here's how:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">View Your Account:</BodyText>
              <BodyText variant="large"> Navigate to the top right-hand side of the navigation bar and click on "Account."</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Select "Profile" from the Dropdown:</BodyText>
              <BodyText variant="large"> In the dropdown menu that appears, locate and click on "Profile."</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Access Your Profile Page:</BodyText>
              <BodyText variant="large"> Once you're on the Profile page, select "My Profile" to access your personal information.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Add Frequent Flyer Program:</BodyText>
              <BodyText variant="large"> Enter the relevant details for the program you wish to add. This will include your frequent flyer number and desired program.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Save Changes:</BodyText>
              <BodyText variant="large"> After entering the information, be sure to save your changes to ensure that your frequent flyer program is successfully added to your account.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
    </Group>
  )
}
